import { data } from "jquery";
import store from "../store";
import CryptoJS from 'crypto-js';

// all these utility methods are for whole app. generalization purpose

export const getBaseUrl = () => {
    // var baseUrl = "https://pagcor-api.talentmap.ai/";
    // var baseUrl = "http://127.0.0.1:8000/";
    // var baseUrl = "https://pagcor-api.talentmap.ai/";
     var baseUrl = "https://beta-pagcor-api.talentmap.asia/";

    return baseUrl;
}

export const generateToken = () =>{

    const encryptData = (data, key) => {
        const iv = CryptoJS.lib.WordArray.random(16); // 16 bytes for AES
        const keyBytes = CryptoJS.enc.Hex.parse(key); // Convert the hex key to bytes
        const encrypted = CryptoJS.AES.encrypt(data, keyBytes, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return iv.toString(CryptoJS.enc.Hex) + ':' + encrypted.toString(); // Combine IV and encrypted data
    };

    const adminData = localStorage.getItem('userAdminData')
    
    if(!adminData  || JSON.parse(adminData).is_superadmin) {
        const data = encryptData('xyfttfg23', 'b7d8e4a2c6e9b1f8a3f1e5c9d4c5e3a7')
        localStorage.setItem('app_id_session', data);
    } else if(adminData) {
        const data = encryptData(adminData, 'b7d8e4a2c6e9b1f8a3f1e5c9d4c5e3a7')
        localStorage.setItem('app_id_session', data);
    } 
    // else {
    //     if(JSON.parse(adminData).is_superadmin) {
    //         const data = encryptData('xyfttfg23', 'b7d8e4a2c6e9b1f8a3f1e5c9d4c5e3a7')
    //         localStorage.setItem('app_id_session', data);
    //     }
    // }

    const timestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds
    console.log(timestamp);
    const randomString = Math.random().toString(36).substring(2, 15); // Generate a random string
    const otherKeyword = Math.random().toString(35).substring(2, 16); // Generate a random string

    // Combine the parts with the delimiter
    const payload = `${randomString}||${timestamp}||${otherKeyword}`;

    // Encode the payload using base64
    // const token = btoa(payload);
    const token = encryptData(payload, 'b7d8e4a2c6e9b1f8a3f1e5c9d4c5e3a7')
    console.log("########### Token ########", token)
    return token;
}


let year = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '2024' : new Date().getFullYear().toString();

export const getYear = () => {

    return 2024;

}

export const updateYear = (newYear) => {
    year = newYear;
}


// export const getYear = () => {
//     return !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '2021' : /*new Date().getFullYear()*/ '2021';
// }
export const accessToken = () => {
    return "9b57b0a7bc481a375b3dcf990938c572";
}
//autoFocus next fields when maxLength is exceed for focused field.
export const autoFocusNextField = (parentClass) => {
    var container = document.getElementsByClassName(parentClass)[0];
    container.onkeyup = function(e) {
        var target = e.srcElement;
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;
        if (myLength >= maxLength) {
            var next = target;
            // console.log(next);
            while (next = next.nextElementSibling) {
                if (next == null)
                    break;
                if (next.tagName.toLowerCase() == "input") {
                    next.focus();
                    // console.log();
                    if(next.value == '-'){
                        var nextPass = document.getElementById(next.nextElementSibling.id);
                        nextPass.focus();
                    }

                    break;
                }
            }
        }
    }
}

//get the logged in employee profile data
export const getEmployeeProfile = () => { 
    
    if(localStorage.getItem('pagCorUserProfile') && localStorage.getItem('pagCorUserProfile') != '') {

        var emp_profile = JSON.parse(localStorage.getItem('pagCorUserProfile'));
        
        return emp_profile;
        
    }
    else{
        return false;
    }

};
//get the user related data
export const getEmployeeRelatedData = () => {
    if(localStorage.getItem('userRelatedData') && localStorage.getItem('userRelatedData') != '') {

        var userRelatedData = JSON.parse(localStorage.getItem('userRelatedData'));
        
        return userRelatedData;
        
    }
    else{
        return {};
    }
}
//check if the logged in employee is supervisor also or not
export const checkIfEmpSupervisor = () => { 
    
    if(localStorage.getItem('userIsSupervisor') && localStorage.getItem('userIsSupervisor') == '1') {
        return true;
    }
    else{
        return false;
    }

};

//check if the logged in employee is admin also or not
export const checkIfEmpIsAdmin = () => { 
    
    if(localStorage.getItem('userIsAdmin') && localStorage.getItem('userIsAdmin') == '1') {
        return true;
    }
    else{
        return false;
    }

};

// This method specific to forms functionality
export const getUserData = () => { 
    
    if(localStorage.getItem('userData') && localStorage.getItem('userData') != '') {

        var userData = JSON.parse(localStorage.getItem('userData'));
        
        return userData;
        
    }
    else{
        return false;
    }

};
export const validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export const getAdminUserData = () => { 
    
    if(localStorage.getItem('userAdminData') && localStorage.getItem('userAdminData') != '') {

        var adminData = JSON.parse(localStorage.getItem('userAdminData'));
        
        return adminData;
        
    }
    else{
        return false;
    }

};



// This method specific to forms functionality
export const replaceImagePathCkEditor = (html) => {
    if(html.indexOf("/userfiles/images") > -1) {
        var updatedHtml = html.replace(/\/userfiles/gi, "http://forms-neuro.testedtalent.com/userfiles");
        return updatedHtml;
    } else {
        return html;
    }
};

export const isMobileBrowser = () => {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}
 export const convertInArray = (objData ,callback) => {
     console.log(objData,"above loop")
    let arrData = [];
    let flag = 1;
    objData.map((assess,index) => {
        arrData.push(assess)
        if (objData.length == flag) {
            console.log("sending data back",arrData)
            callback(arrData);
        }
        //console.log(arrData,"in  loop")
    flag++
     }) 
 }
 // Function to perform the logout process
const performLogout = () => {
    // localStorage.clear();
    localStorage.removeItem("isLoggedInPagCor");
    localStorage.removeItem("pagCorUserProfile");
    localStorage.removeItem("allowAssessments");
    localStorage.removeItem("userIsSupervisor");
    localStorage.removeItem("userSubOrdinates");
    localStorage.removeItem("userIsAdmin");
    localStorage.removeItem("adminType");
    localStorage.removeItem("app_id_session");
    
    window.location.href = "/#/login";
    window.location.reload();
}
 export const relogin = (message, statusCode) => {
    if((statusCode == 403) && (message == 'Access permissions have changed, please relogin.' || message == 'Admin role removed or invalid.')) {

             // Show confirmation dialog
alert(`${message}!`);
     // User confirmed, proceed with immediate logout
     performLogout();
    }
    else if(statusCode == 429){

        debugger;
        const currentPath = window.location.pathname;
        console.log('currentPath: ', currentPath);
        const hash = window.location.hash;
        console.log('hash: ', hash);
    
        // Check if the currentPath contains '/login' and ignore hash fragment (/#/)
        if (hash.includes('/login') || (hash.endsWith('#/'))) {
            performLogout();
        }  else{
            
            if (!hash.includes('/assessment')){
                window.location.reload();
            }
            

        }
    }
};